import { AsyncStoreItem } from '@lib/store';
import { SearchDecryptionResponse } from 'src/sdk-servicing';

/**
 * SearchDecryption model
 */
export interface SearchDecryptionModel {
  model: SearchDecryptionResponse | null;
}

/**
 * SearchDecryptionResponse model details
 */
export interface SearchDecryptionStateDetails extends AsyncStoreItem {}

/**
 * SearchDecryption store state
 */
export interface SearchDecryptionState extends SearchDecryptionStateDetails, SearchDecryptionModel {}

/**
 * Name of the SearchDecryption Store
 */
export const SEARCH_DECRYPTION_STORE_NAME = 'searchDecryption';

/**
 * SearchDecryption Store Interface
 */
export interface SearchDecryptionStore {
  /** SearchDecryption state */
  [SEARCH_DECRYPTION_STORE_NAME]: SearchDecryptionState;
}
